import { memo } from 'react';
import { useTranslation } from '@aimsos/i18n';
import { EntityList } from '@aimsos/ui';

import { NOTE_KIND_ICON } from './noteKindIcons.js';

import { Bot, Sparkles } from 'lucide-react';

/**
 * One reading of a meeting record, drawn INSIDE its card on From notes
 * (CT-5724, as in the prototype): "Topics" with the spark, what was read, and
 * "Concierge · from <file>". "Fix" and "Flag as claim" wait for the PM (open
 * question 2), so they are not built.
 */
const NoteInsightTopic = memo(function NoteInsightTopic({ topic }) {
  const { t } = useTranslation('unified-profiles');

  return (
    <div data-testid="note-insight-topic" data-note-kind={topic.kind} className="mt-3 border-t border-edge pt-3">
      <EntityList
        title={topic.title ?? t(`history.notes.headings.${topic.kind}`)}
        icon={NOTE_KIND_ICON[topic.kind] ?? Sparkles}
        iconHighlight={{ bgColor: 'Purple', iconColor: 'Purple' }}
        description={topic.text}
        secondaryMeta={topic.origin ? [{ id: 'origin', icon: Bot, label: t('history.notes.origin', { origin: topic.origin }) }] : undefined}
      />
    </div>
  );
});

export default NoteInsightTopic;
